import { Directive, ElementRef, AfterViewInit, Self, Optional } from '@angular/core';
import { TextInput } from 'ionic-angular';
import Cleave from 'cleave.js';

@Directive({
  selector: '[poNumber]',
})
export class PurchaseNumberDirective implements AfterViewInit {

  private cleave: Cleave;

  constructor(
    @Self() @Optional() private ionInput: TextInput,
  ) {}

  async ngAfterViewInit() {
    this.createCleave();
  }

  createCleave() {
    const element = this.ionInput.getNativeElement().querySelector('input') as HTMLElement;
    this.cleave = new Cleave(element, {
      delimiters: ['-', '-'],
      blocks: [3, 2, 5],
      uppercase: true
    });
  }

  ngOnDestroy() {
    if (this.cleave) {
      this.cleave.destroy();
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/po-number.directive.ts